module.exports = __webpack_public_path__ + "img/ecolab_logo.34a185fb.svg";